import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

export const StyledAvailabilityTimeSlotManualDuration = styled.div`
   align-self: flex-end;
   align-items: center;
   width: 110px;
   display: flex;
   gap: 12px;

   > span {
      ${basicBodyTextStyle};
      align-self: center;
   }
`;
StyledAvailabilityTimeSlotManualDuration.displayName = 'StyledAvailabilityTimeSlotManualDuration';
